import { DomainGroup, getCurrentDomainGroup } from "@shared/utils/domain-group";

export const useDomainGroup = (): DomainGroup => getCurrentDomainGroup();
